import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, Self, input } from '@angular/core';
import { ControlValueAccessor, NgControl, ReactiveFormsModule } from '@angular/forms';

import { FormControlPipe } from '@shared/pipe';
import { DigitOnlyDirective } from '@shared/directive';
import { IButtonCustomClass, IFormCustomClass } from '@data/schema';

@Component({
    selector: 'app-text-input',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormControlPipe, DigitOnlyDirective],
    templateUrl: './text-input.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
})
export class TextInputComponent implements ControlValueAccessor {
    label = input.required<string>();
    secondaryLabel = input<string>();
    placeholder = input<string>();
    type = input<string>('text');
    inputIcon = input<string>();
    inputGroupAppendEnabled = input<boolean>(false);
    inputGroupAppendText = input<string>();
    inputGroupAppendButtonText = input<string>();
    inputGroupAppendButtonIcon = input<string>();
    inputGroupAppendButtonProcessing = input<boolean>(false);
    inputGroupAppendButtonDisabled = input<boolean>(false);
    inputGroupPrependEnabled = input<boolean>(false);
    inputGroupPrependText = input<string>();
    inputGroupPrependButtonText = input<string>();
    inputGroupPrependButtonProcessing = input<boolean>(false);
    inputGroupPrependButtonDisabled = input<boolean>(false);
    inputDecimalCheckEnabled = input<boolean>(false);
    inputDecimalPattern = input<RegExp>(/^\d+(\.\d{1,2})?$/);
    inputIntegerOnlyCheckEnabled = input<boolean>(false);
    inputStepCount = input<number>(1);
    inputStepMin = input<number | null>(null);
    inputRequiredIndicatorEnabled = input<boolean>(false);
    inputRequiredBorderEnabled = input<boolean>(false);
    inputIsReadOnly = input<boolean>(false);
    customValidationMessages = input<Record<string, string>>({});
    testAutomationSelectorName = input<string>();
    customClasses = input<IFormCustomClass>({
        formGroup: 'mb-3',
        label: 'form-label fw-medium mb-2',
        input: 'form-control',
        secondaryLabel: 'form-text',
        inputGroupLabel: 'input-group-text',
    });
    inputGroupPrependButtonCustomClasses = input<IButtonCustomClass>({
        button: 'btn btn-outline-secondary',
        spinner: 'spinner-border spinner-border-sm',
    });
    inputGroupAppendButtonCustomClasses = input<IButtonCustomClass>({
        button: 'btn btn-outline-secondary',
        spinner: 'spinner-border spinner-border-sm',
    });

    @Output() onAppendButtonClick = new EventEmitter<boolean>();
    @Output() onPrependButtonClick = new EventEmitter<boolean>();
    @Output() onKeyUpEnterPress = new EventEmitter<boolean>();

    inputFocused = false;

    constructor(@Self() public ngControl: NgControl) {
        this.ngControl.valueAccessor = this;
    }

    writeValue(_obj: any): void {}
    registerOnChange(_fn: any): void {}
    registerOnTouched(_fn: any): void {}

    onAppendClick() {
        this.onAppendButtonClick.emit(true);
    }

    onPrependClick() {
        this.onPrependButtonClick.emit(true);
    }

    onKeyUpEnter() {
        this.onKeyUpEnterPress.emit(true);
    }

    onInputFocus(focused: boolean) {
        this.inputFocused = focused;
    }
}
